import React, { useState } from 'react';
import { InputDropdown, InputField } from '../../elements';
import styles from './style.module.css';

export default function RenderInputLoop(props) {
  const { inputList, storage } = props;

  const [answer15, setAnswer15] = useState('');
  const [answer16, setAnswer16] = useState('');

  const [answer82, setAnswer82] = useState('');
  const [answer83, setAnswer83] = useState('');

  /* Conditional Input "Aliran Sungai" (3 input, id = 15,16,17) */
  const handleChangeAnswer15 = (value) => {
    if (value === 'Ya') {
      setAnswer15(value);
    } else if (value === 'Tidak') {
      setAnswer15(value);
      setAnswer16(value);
    }
  };

  /* Conditional Input "Verifikator" (3 input, id = 82,83,84) */
  const handleChangeAnswer82 = (value) => {
    if (value === 'Ya') {
      setAnswer82(value);
    } else if (value === 'Tidak') {
      setAnswer82(value);
      setAnswer83(value);
    }
  };

  return (
    <>
      {inputList &&
        inputList.map((element, _index) => {
          let defaultValue = '';
          storage &&
            storage.forEach((localItem) => {
              if (
                parseInt(localItem.question_id) === parseInt(element.questionId)
              ) {
                defaultValue = localItem.answer;
              }
            });

          // Checking questionId 16 & 17 (Aliran Sungai) , 83 & 84 (Verifikator)
          if (element.questionId === 16) {
            return (
              <React.Fragment key={`wrapper-dropdown-${element.questionId}`}>
                {element.questionId === 16 && answer15 === 'Ya' ? (
                  <InputDropdown
                    key={`dropdown-${element.questionId}`}
                    className={styles.inputRoot}
                    name={`inputWithQuestionId${element.questionId}`}
                    label={element.question}
                    defaultValue={defaultValue}
                    options={element.answerList && element.answerList}
                    required={element.required}
                    setInputValue={setAnswer16}
                  />
                ) : (
                  ''
                )}
              </React.Fragment>
            );
          } else if (element.questionId === 17) {
            return (
              <React.Fragment key={`wrapper-dropdown-${element.questionId}`}>
                {element.questionId === 17 && answer16 === 'Ya' ? (
                  <InputField
                    key={`dropdown-${element.questionId}`}
                    className={styles.inputRoot}
                    name={`inputWithQuestionId${element.questionId}`}
                    label={element.question}
                    type={element.dataType}
                    defaultValue={defaultValue}
                    pattern="[a-zA-Z0-9\s]+"
                    required={element.required}
                  />
                ) : (
                  ''
                )}
              </React.Fragment>
            );
          } else if (element.questionId === 83) {
            return (
              <React.Fragment key={`dropdown-${element.questionId}`}>
                {element.questionId === 83 && answer82 === 'Ya' ? (
                  <InputDropdown
                    className={styles.inputRoot}
                    name={`inputWithQuestionId${element.questionId}`}
                    label={element.question}
                    defaultValue={defaultValue}
                    options={element.answerList && element.answerList}
                    required={element.required}
                    setInputValue={setAnswer83}
                  />
                ) : (
                  ''
                )}
              </React.Fragment>
            );
          } else if (element.questionId === 84) {
            return (
              <React.Fragment key={`dropdown-${element.questionId}`}>
                {element.questionId === 84 && answer83 === 'Ya' ? (
                  <InputField
                    className={styles.inputRoot}
                    name={`inputWithQuestionId${element.questionId}`}
                    label={element.question}
                    type={element.dataType}
                    defaultValue={defaultValue}
                    pattern="[a-zA-Z0-9\s]+"
                    required={element.required}
                  />
                ) : (
                  ''
                )}
              </React.Fragment>
            );
          } else {
            if (element.answerList) {
              return (
                <InputDropdown
                  key={`dropdown-${element.questionId}`}
                  className={styles.inputRoot}
                  name={`inputWithQuestionId${element.questionId}`}
                  label={element.question}
                  defaultValue={defaultValue}
                  options={element.answerList && element.answerList}
                  required={element.required}
                  setInputValue={
                    element.questionId === 82
                      ? handleChangeAnswer82
                      : element.questionId === 15
                      ? handleChangeAnswer15
                      : ''
                  }
                  // alertMessage=""
                />
              );
            } else {
              return (
                <InputField
                  key={`dropdown-${element.questionId}`}
                  className={styles.inputRoot}
                  name={`inputWithQuestionId${element.questionId}`}
                  label={element.question}
                  type={element.dataType}
                  defaultValue={defaultValue}
                  pattern="[a-zA-Z0-9\s]+"
                  required={element.required}
                  // alertMessage=""
                />
              );
            }
          }
        })}
    </>
  );
}
